/**
 * Добавляет слэш в конце строки урл
 */
export const correctPathname = (pathname: string) => {
  return `/${pathname}/`.replace(/(\/){2,}/g, '/');
};
